import { render, staticRenderFns } from "./SectionTable.vue?vue&type=template&id=45dd913b&scoped=true"
import script from "./SectionTable.vue?vue&type=script&lang=js"
export * from "./SectionTable.vue?vue&type=script&lang=js"
import style0 from "./SectionTable.vue?vue&type=style&index=0&id=45dd913b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dd913b",
  null
  
)

export default component.exports